module.exports = __webpack_public_path__ + "static/media/4. Ardiansyah.127c8b26.png";